<form class="form-vertical" id="editsafeform" data-hook="editsafeform">
    <div class="row">
        <div class="form-group col-md-6 col-xs-12">
            <label for="username">Username</label>
            <input type="text" id="username" ng-model="vm.user.username"
                   class="form-control"
                   placeholder="Username" required>
        </div>
        <div class="col-xs-12 col-md-6 form-group">
            <label for="password">Passwort</label>
            <input type="password" id="password" ng-model="vm.user.password" placeholder="Passwort" class="form-control"
                   required>
        </div>
    </div>
    <div class="row">
        <div class="col-xs-12 form-group">
            <label for="role">Rolle</label>
            <select id="role" ng-model="vm.user.role" class="form-control">
                <option ng-repeat="role in vm.roles" value="{{role.role}}" >{{role.label}}</option>
            </select>
        </div>
    </div>
    <div class="row">
        <div class="col-xs-12 form-group">
            <label for="realName">Vor- und Nachname</label>
            <input type="text" ng-model="vm.user.realName" id="realName" class="form-control"
                   placeholder="Vor- und Nachname">
        </div>
    </div>
    <div class="row">
        <div class="col-xs-12 form-group">
            <label for="email">E-Mail</label>
            <input type="email" id="email" ng-model="vm.user.email"
                   placeholder="E-Mail" class="form-control">
        </div>
    </div>
    <div class="row">
        <div class="col-xs-12 form-group">
            <label for="telnum">Telefonnummer</label>
            <input id="telnum" ng-model="vm.user.tel" type="tel" class="form-control" placeholder="Telefonnummer">
        </div>
    </div>

<!--
    <div class="row">
        <div class="form-group col-xs-12 col-md-4">
            <label for="roles">Typ</label>
            <select class="form-control" tabindex="0" ng-model="vm.user.roles" id="roles" multiple>
                <option>Admin</option>
                <option>Techniker</option>
                <option>Main-Mitarbeiter</option>
            </select>
        </div>
    </div>-->

    <div class="row">
        <div class="col-xs-12 form-group">
            <label for="comment">Anmerkungen</label>
            <textarea ng-model="vm.user.comment" id="comment" class="form-control" placeholder="Anmerkungen"></textarea>
        </div>
    </div>

    <div class=" row">
        <div class="col-xs-12">
            <div class="form-group">
                <button class="btn btn-success" type="button" tabindex="9" ng-click="vm.save()">Speichern</button>
                <button class="btn btn-danger" type="button" tabindex="10" ng-click="vm.cancel()">Abbrechen</button>
            </div>
        </div>
    </div>
</form>